import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { ChatPanelHelper } from './helpers/chat-panel-helper';
import type { ChatPanelPageDescriptor } from './types/types';

/** The page the panel is attached to, as it will be described to the assistant. */
export const usePageDescriptor = (): ChatPanelPageDescriptor | null => {
  const { pathname, query } = useRouter();

  return useMemo(
    () => ChatPanelHelper.buildPageDescriptor(pathname, query),
    [pathname, query]
  );
};
